import { useMutation } from "@tanstack/react-query";
import { queryClient } from "../../../index";
import { ReactQueryKeys } from "constants/keys";
import api from "api/";
import { ObservationTypeGroup } from "../models/ObservationTypeGroup";

const createObservationTypeGroup = async ({
  name,
  observation_type_ids,
}: {
  name: string;
  observation_type_ids: string[];
}) => {
  const response = await api.client.ObservationTypeGroup.create({
    body: {
      observation_type_group: {
        name: name,
        observation_type_ids: observation_type_ids,
      },
    },
  });

  if (!response.ok) {
    const error = `Error creating Observation Type Group ${response.error}`;
    console.error(error);
    throw new Error(error);
  }

  return response.body as ObservationTypeGroup;
};

export const useCreateObservationTypeGroup = () => {
  return useMutation(createObservationTypeGroup, {
    onSuccess: () => {
      queryClient.invalidateQueries([ReactQueryKeys.OBSERVATION_TYPE_GROUPS]);
    },
  });
};
